var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('p', {
    staticClass: "p1",
    class: _vm.$style.label
  }, [_vm._v(" " + _vm._s(_vm.label) + ": "), _vm.isRequired && _vm.editMode ? _c('span', {
    class: _vm.$style.requiredAsterisk,
    attrs: {
      "data-required-asterisk": ""
    }
  }, [_vm._v("*")]) : _vm._e()]), !_vm.editMode ? [_vm.value.length ? _c('ul', {
    class: _vm.$style.valuesList
  }, _vm._l(_vm.value, function (item) {
    return _c('li', {
      key: item.id ? item.id : item.state
    }, [_vm._v(" " + _vm._s(item.state) + " "), item.number ? [_vm._v("- " + _vm._s(item.number))] : _vm._e()], 2);
  }), 0) : _c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s('N/A'))])] : _vm._e(), _vm.editMode ? [_c('ValidationProvider', {
    attrs: {
      "debounce": 300,
      "name": _vm.label,
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors,
          changed = _ref.changed;
        return [_c('BaseMultiSelect', {
          attrs: {
            "options": _vm.stateOptions,
            "option-text": "state",
            "disabled": _vm.disabled || _vm.stateOptions.length === 0,
            "placeholder": _vm.placeholder,
            "changed": changed
          },
          on: {
            "input": _vm.onInput
          },
          scopedSlots: _vm._u([{
            key: "tag",
            fn: function fn(_ref2) {
              var option = _ref2.option,
                remove = _ref2.remove;
              return [_c('span', {
                staticClass: "multiselect__tag",
                class: _vm.isRemovable(option.state) ? '' : 'multiselect__tag-readonly',
                on: {
                  "mousedown": function mousedown($event) {
                    $event.preventDefault();
                  }
                }
              }, [_c('span', [_vm._v(_vm._s(option.state))]), _vm.isRemovable(option.state) ? _c('i', {
                staticClass: "multiselect__tag-icon",
                on: {
                  "click": function click($event) {
                    $event.stopPropagation();
                    return remove(option);
                  }
                }
              }) : _vm._e()])];
            }
          }], null, true),
          model: {
            value: _vm.modelValue,
            callback: function callback($$v) {
              _vm.modelValue = $$v;
            },
            expression: "modelValue"
          }
        }), errors[0] ? _c('p', {
          staticClass: "tag-text",
          class: _vm.$style.errorMessage
        }, [_vm._v(_vm._s(errors[0]))]) : _vm._e()];
      }
    }], null, false, 4094327075)
  }), _vm._l(_vm.modelValue, function (state) {
    return _c('div', {
      key: state.state,
      class: _vm.$style.licenseNumberInputContainer
    }, [_c('ValidationProvider', {
      staticClass: "d-contents",
      attrs: {
        "debounce": 300,
        "name": state.state
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref3) {
          var stateChanged = _ref3.changed;
          return [_c('p', {
            staticClass: "p1",
            class: _vm.$style.licenseNumberLabel
          }, [_vm._v(_vm._s(state.state + ': '))]), _c('BaseInputText', {
            staticClass: "ml-1",
            attrs: {
              "disabled": _vm.disabled || _vm.readOnlyValues.some(function (readOnlyState) {
                return readOnlyState.state === state.state;
              }),
              "name": state.state + ' - ',
              "changed": stateChanged,
              "maxlength": "30",
              "placeholder": "License Number"
            },
            model: {
              value: state.number,
              callback: function callback($$v) {
                _vm.$set(state, "number", $$v);
              },
              expression: "state.number"
            }
          })];
        }
      }], null, true)
    })], 1);
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }